import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminCustomer } from "../../../domain/administrator/model";

type CustomerByIdState = {
  loading: boolean;
  data: AdminCustomer;
};

const initialState: CustomerByIdState = {
  loading: false,
  data: {
    email: "",
    name: "",
    phone: "",
    jobRole: null,
    acceptNotifications: false,
    role: "Customer",
    topics: [],
    challenges: [],
    twoFactorAuthentication: false,
    image: null,
    area: null,
    birthDate: null,
    language: "pt",
    createdAt: "",
    updatedAt: "",
    id: "",
    company: {
      id: "",
      name: "",
      paid: false,
    },
  },
};

const dataSlice = createSlice({
  name: "Customer/detail",
  initialState: initialState,
  reducers: {
    eraseCustomerStore: () => {
      return { ...initialState };
    },
    setCustomerLoading: (state) => {
      state.loading = true;
    },
    setCustomerResult: (state, action: PayloadAction<AdminCustomer>) => {
      state.data = action.payload;
      state.loading = false;
    },
    setCustomerFailure: (state) => {
      state.loading = false;
    },
  },
});

export const {
  eraseCustomerStore,
  setCustomerFailure,
  setCustomerLoading,
  setCustomerResult,
} = dataSlice.actions;

export default dataSlice.reducer;
